const setAmexSessionTarget = (originLink: string) => {
  if (global.BROWSER) {
    let timer: string | number | NodeJS.Timeout | undefined;
    const clearSetTarget = () => {
      if (timer) {
        clearTimeout(timer);
      }
    };

    const setTarget = () => {
      const redirectURL = encodeURIComponent(
        `${originLink}/en-us/business/payment-solutions/supplier-dashboard/home`
      );
      if (window.AmexSession) {
        window.AmexSession.options({
          target: redirectURL,
        });
        clearSetTarget();
      } else {
        clearSetTarget();
        timer = setTimeout(setTarget, 100);
      }
    };
    setTarget();
  }
};

export default setAmexSessionTarget;
